import { BUDGET_MANAGER_TAG_GROUP_SLUG_PREFIX } from './budget-manager.constants';

export const getBudgetManagerTagGroup = data => data.find(
    tagGroup => isBudgetManagerTagGroup(tagGroup?.slug),
);

export const isBudgetManagerTagGroup = slug => slug?.includes(BUDGET_MANAGER_TAG_GROUP_SLUG_PREFIX);
